import React, { useRef, useState, useEffect } from 'react';
import { DatetimepickerWrapper } from '@@Components/Datetimepicker/styled';
import { Datepicker } from '@@Components/Datepicker';
import { DatepickerRange } from '@@Components/Datepicker/utils/datepicker-range';
import { useLang } from '@@Components/hooks/useLang';
import { Select } from "@@Components/Select/Select";
import dayjs from 'dayjs';
export const Datetimepicker = React.forwardRef((props, ref) => {
    const { error, placeholder, onBlur, label, required, timepickerLabel, onChange, minimalDate, blockSunday, value, } = props;
    const timeRef = useRef();
    const [date, setDate] = useState(null);
    const [time, setTime] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [options, setOptions] = useState([]);
    const { translate } = useLang();
    const getValue = (e, action) => {
        if (action === 'date')
            setDate(e);
        if (action === 'time')
            setTime(e.value);
    };
    useEffect(() => {
        if (date)
            setDisabled(false);
        if (onChange && !!(date || time))
            onChange(date + (time ? ` ${time}` : ''));
    }, [date, time]);
    useEffect(() => {
        if (date) {
            let tempOptions = [];
            const day = Number(date.split('/')[2]);
            const month = Number(date.split('/')[1]) - 1;
            const year = Number(date.split('/')[0]);
            const selectedDate = new Date(year, month, day);
            const selectDayFormat = dayjs(selectedDate).format('YYYY/MM/DD');
            const todayDay = dayjs().format('YYYY/MM/DD');
            const todayHour = dayjs().format('HH:mm');
            const limit = todayDay === selectDayFormat;
            if (selectedDate.getDay() === 0 || selectedDate.getDay() === 6) {
                const allHours = ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00'];
                allHours.map(el => {
                    if (limit) {
                        const hour = dayjs(`${selectDayFormat} ${el}`).format('HH:mm');
                        if (!(hour <= todayHour))
                            tempOptions.push({ value: el, label: el });
                    }
                    else
                        tempOptions.push({ value: el, label: el });
                });
            }
            else {
                const allHours = ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'];
                allHours.map(el => {
                    if (limit) {
                        const hour = dayjs(`${selectDayFormat} ${el}`).format('HH:mm');
                        if (!(hour <= todayHour))
                            tempOptions.push({ value: el, label: el });
                    }
                    else
                        tempOptions.push({ value: el, label: el });
                });
            }
            setOptions(tempOptions);
        }
    }, [date]);
    useEffect(() => {
        var _a;
        setTime((_a = options[0]) === null || _a === void 0 ? void 0 : _a.value);
    }, [options]);
    useEffect(() => {
        if (value === null) {
            setDate(null);
            setTime(null);
        }
    }, [value]);
    return (React.createElement(DatetimepickerWrapper, { ref: ref },
        React.createElement(Datepicker, { error: error, minimalDate: minimalDate, blockSunday: blockSunday, placeholder: placeholder, range: DatepickerRange.DAY, options: options, outputFormat: "YYYY/MM/DD", value: date, onChange: (e) => getValue(e, 'date'), onBlur: () => onBlur && onBlur(), label: label, required: required }),
        React.createElement(Select, { placeholder: placeholder || translate('placeholders.hour'), options: options, label: timepickerLabel || translate('placeholders.hour'), ref: timeRef, required: false, value: time, error: error, disabled: disabled, onBlur: () => onBlur && props.onBlur(), onChange: (e) => getValue(e, 'time') })));
});
